export default "__VITE_ASSET__CShMDQOe__"